import { Outlet, ScrollRestoration } from "react-router-dom";
import { Header } from "./Header.jsx";
import { Footer } from "./Footer.jsx";
import { Analytics } from "../shared/Analytics.jsx";

/**
 * Outer shell for every public route. Header is fixed, so we add top padding
 * to push page content below it. ScrollRestoration brings the user back to
 * the top of the new route on navigation.
 */
export function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Analytics />
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
